import Login from './components/Login'
import RecuperarSenha from './components/RecuperarSenha'

export default [
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      breadcrumb: {
        name: 'Login'
      },
      auth: false
    }
  },
  {
    path: '/recuperacao-de-acesso',
    component: Login,
    name: 'recuperacao-de-acesso',
    meta: {
      breadcrumb: {
        name: 'Recuperação de Acesso'
      },
      auth: false
    }
  },
  {
    path: '/recuperar-senha/:hash?',
    component: RecuperarSenha,
    name: 'recuperar-senha',
    meta: {
      breadcrumb: {
        name: 'Recuperar Senha'
      },
      auth: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/domains/login/routes.js